// Music Volume Migration Utility
// This function updates users who have the old default volume (50%) to the new default (100%)

export const migrateMusicVolume = () => {
  const MIGRATION_KEY = 'musicVolumeMigrated';
  const OLD_DEFAULT = '0.5';
  const NEW_DEFAULT = '1';
  
  // Check if migration has already been performed
  if (localStorage.getItem(MIGRATION_KEY) === 'true') {
    console.log('Music volume migration already performed');
    return false;
  }
  
  // Get current music volume
  const currentVolume = localStorage.getItem('musicVolume');
  
  // If volume is exactly the old default (0.5), update it to new default (1.0)
  if (currentVolume === OLD_DEFAULT) {
    localStorage.setItem('musicVolume', NEW_DEFAULT);
    console.log('Music volume migrated from 50% to 100%');
  }
  
  // Mark migration as complete
  localStorage.setItem(MIGRATION_KEY, 'true');
  
  return true;
};